export const constants = {
    // baseUrl: 'http://192.168.118.1729/api/v1',
    baseUrl: 'https://deentire-api-rj2w.onrender.com/api/v1',
    // baseUrl: 'https://baroobo-deentire-api.onrender.com/api/v1',
    moneySign: "$",
    token: "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjYzYjE5N2IzN2Y1ZjE2NzQxMDliZjIyYSIsImlhdCI6MTcyMTE5OTQxNCwiZXhwIjoxNzIzNzkxNDE0fQ.ZftDO2bRaUEssa3VXCPung2uWBc7eti8RokoPLtL5jE",
}